//#region ENUM UserAccessStatusEnum

/**
 * ### UserAccessStatusEnum
 * Enum representing the possible access statuses of a user.
 *
 * - `ACTIVE`: User currently has valid access.
 * - `EXPIRED`: User's access has expired.
 * - `PENDING`: User's access is awaiting activation or approval.
 * - `VERIFIED`: User has completed verification (e.g., email or admin approval).
 *
 * @enum {string}
 * @description This enum defines the various access statuses a user can have within the system.
 *              It is used to track the state of a user's access and determines what actions or features the user can interact with.
 *
 * @example
 * const status: UserAccessStatusEnum = UserAccessStatusEnum.ACTIVE;
 */
export enum UserAccessStatusEnum {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
}

//#endregion

//#region TYPE UserAccessStatus

/**
 * ### UserAccessStatus
 * Type representing the string literal values from the UserAccessStatusEnum.
 *
 * @typedef {('ACTIVE' | 'EXPIRED' | 'PENDING' | 'VERIFIED')} UserAccessStatus
 * @description This type ensures that only the valid access statuses from the `UserAccessStatusEnum` can be used.
 *
 * @example
 * const status: UserAccessStatus = 'ACTIVE';
 */
export type UserAccessStatus = `${UserAccessStatusEnum}`;

//#endregion

//#region INTERFACE IUserAccess

//#endregion
